import { connect } from 'react-redux';
import {
    getCitationDetail,
    getCitationLoading,
    getCitationEditForm,
    getCitationType,
    getLoadMoreCitationCommentList,
    getLoadMoreCitationFile,
} from '../../store/selectors/citation.selectors';
import {
    getCitationDetailBegin,
    getCitationsFileListBegin,
    updateCitationBegin,
    getCitationCommentListBegin,
} from '../../store/actions/citation.actions';
import { getPersonDetail } from '../../store/selectors/person.selectors';
import { getPersonDetailBegin } from '../../store/actions/person.actions';
import { setActiveTab } from '../../store/actions/license.actions';
import CitationDetailTabs from './CitationDetailTabs';
import { getMergeTemplatesList } from 'src/store/selectors/license.selectors';
import { getMergeTemplatesBegin, mergeDocumentsBegin } from 'src/store/actions/license.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getCitationLoading(state);
    const citationDetail = getCitationDetail(state);
    const editForm = getCitationEditForm(state);
    const hasMoreFiles = getLoadMoreCitationFile(state);
    const citationType = getCitationType(state);
    const personDetail = getPersonDetail(state);
    const hasMoreCitationComments = getLoadMoreCitationCommentList(state);
    const mergeTemplatesList = getMergeTemplatesList(state);

    return {
        isLoading,
        citationDetail,
        personDetail,
        editForm,
        hasMoreFiles,
        citationType,
        hasMoreCitationComments,
        mergeTemplatesList,
    };
};

const mapDispatchToProps = {
    getCitationDetails: getCitationDetailBegin,
    setActiveTab: setActiveTab,
    getCitationFileList: getCitationsFileListBegin,
    updateCitation: updateCitationBegin,
    getPersonDetail: getPersonDetailBegin,
    getCitationCommentList: getCitationCommentListBegin,
    getMergeTemplatesBegin,
    mergeDocuments: mergeDocumentsBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(CitationDetailTabs);
